import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {apiInstanceV2} from '../../Apis/AxiosV2';
import {UploadImage} from '../ShareSlice/shareApi';
import {TABLES} from '../../Apis/Tables';
import {FOODIE_MENU_SERVICE, IMAGE_SERVICE} from '../EndPoints';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const GetMeasurementUnits = createAsyncThunk('ingredient/GetMeasurementUnits ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(FOODIE_MENU_SERVICE.getMeasurementUnits).then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetIngredientById = createAsyncThunk('ingredient/GetIngredientById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.getIngredientById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateIngredient = createAsyncThunk("ingredient/CreateIngredient",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(FOODIE_MENU_SERVICE.createIngredient, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateIngredient = createAsyncThunk("ingredient/UpdateIngredient",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(FOODIE_MENU_SERVICE.updateIngredient, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreateIngredientImage = createAsyncThunk(`ingredient/CreateIngredientImage`, async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2.post(FOODIE_MENU_SERVICE.createIngredientImage, params?.imgData).then(async function (response) {
        // this api need id, file and option
                let formData = new FormData();
                formData.append('id', response?.data?.data?.id);
                formData.append('option', TABLES.INGREDIENT);
                formData.append('file', params?.image);
                await dispatch(UploadImage(formData));
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetIngredientImageByIngredientId = createAsyncThunk('ingredient/GetIngredientImageByIngredientId', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.getIngredientImageByIngredientId}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DeleteAllergenById = createAsyncThunk(
  'menu/deleteAllergenById',
  async ({foodieItemId, allergenId }, { dispatch, getState }) => {
    const response = await apiInstance
    .delete(FOODIE_MENU_SERVICE.deleteAllergenById(foodieItemId, allergenId))
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);
export const DeleteDietTypeById = createAsyncThunk(
  'menu/deleteDietTypeById',
  async ({foodieItemId, dietTypeId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(FOODIE_MENU_SERVICE.deleteDietTypeById(foodieItemId, dietTypeId))
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);
export const DeleteIngredientById = createAsyncThunk(
  'menu/deleteIngredientById',
  async ({foodieItemId, ingredientId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(FOODIE_MENU_SERVICE.deleteIngredientById(foodieItemId, ingredientId))
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);

export const CheckOutOrderKitchen = createAsyncThunk("ingredient/CheckOutOrderKitchen",async (params, { dispatch, getState }) => {

    const {id, date} = params;
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.checkOutOrderKitchen}${id}/${date}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const ServedOrderHistory = createAsyncThunk("ingredient/ServedOrderHistory",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`foodie-menu-selection-service/v1/orders/history-served`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
